import React from "react";

// A single tea-leaf SVG shape used for subtle background decoration
export function Leaf({ className = "", style }) {
  return (
    <svg viewBox="0 0 100 100" className={className} style={style} aria-hidden="true">
      <path
        d="M50 4C24 20 8 44 12 76c0 0 2 14 8 20 0-30 12-56 40-74C57 20 62 34 60 48 82 34 92 14 88 4 74 2 60 2 50 4Z"
        fill="currentColor"
      />
      <path d="M22 92C34 66 50 44 76 28" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.5" />
    </svg>
  );
}

// Decorative floating leaves layer for a section
export function LeafField({ className = "" }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      <Leaf className="absolute left-[4%] top-[12%] w-16 h-16 text-olive/15 animate-float" />
      <Leaf
        className="absolute right-[8%] top-[22%] w-24 h-24 text-forest/10 animate-float"
        style={{ animationDelay: "1.5s" }}
      />
      <Leaf
        className="absolute left-[15%] bottom-[10%] w-12 h-12 text-gold/25 animate-float"
        style={{ animationDelay: "3s" }}
      />
      <Leaf
        className="absolute right-[18%] bottom-[18%] w-20 h-20 text-olive/10 animate-float"
        style={{ animationDelay: "0.8s" }}
      />
    </div>
  );
}
